const Images = [
    {
        ID: 1,
        img: require('./moon3.jpg'),
    },
    {
        ID: 2,
        img: require('./moonBump.jpg'),
    },
];

export default Images;
